import React, { memo } from 'react';

import { useAuthState } from '../../contexts/AuthContext';

import NavItem from '../Shared/NavItem';
import PermissionsWrapper from '../PermissionsWrapper';

import styles from './header.module.css';

const SiteNavigation = () => {
	const { user: { permissions } } = useAuthState();

	return (
		<nav
			className={ `${ styles.siteNavigation } no-print` }
		>
			<ul>
				<li>
					<NavItem
						className={ styles.navItem }
						icon="dashboard"
						to="/dashboard"
						title="Dashboard"
					/>
				</li>
				<PermissionsWrapper permission={ permissions.listContacts.isAvailable || permissions.listPrograms.isAvailable }>
					<li>
						<NavItem
							className={ styles.navItem }
							icon="cog"
							to="/operations"
							title="Operations"
						/>
					</li>
				</PermissionsWrapper>
				<PermissionsWrapper permission={ permissions.listAgencies.isAvailable }>
					<li>
						<NavItem
							className={ styles.navItem }
							icon="building"
							to="/agencies"
							title="Agencies"
						/>
					</li>
				</PermissionsWrapper>
				{/* <li>
					<NavItem
						className={ styles.navItem }
						icon="chart bar"
						to="/reports"
						title="Reports"
					/>
				</li> */}
				<PermissionsWrapper permission={ permissions.listUsers.isAvailable }>
					<li>
						<NavItem
							className={ styles.navItem }
							icon="user circle"
							to="/administration"
							title="Administration"
						/>
					</li>
				</PermissionsWrapper>
			</ul>
		</nav>
	);
};

export default memo( SiteNavigation );
